module.exports = __webpack_public_path__ + "img/zfcg_10.100f4e40.png";